<template>
	<div class="agreement-page">
		<div class="agreement-title">智能客服服务协议</div>
		<agreementContent></agreementContent>
	</div>
</template>

<script>
import agreementContent from './components/agreementContent.vue'
export default {
	components: {
		agreementContent,
	},
}
</script>

<style lang="less" scoped>
.agreement-page {
	padding: 0.32rem 0.64rem;
	background: #fff;
	font-family: PingFang SC;

	.agreement-title {
		font-size: 16px;
		line-height: 24px;
		font-weight: 500;
		margin-bottom: 12px;
		text-align: center;
	}
}
@media screen and (max-width: 924px) {
	.agreement-title {
		font-size: 0.4267rem;
		line-height: 0.64rem;
		margin-bottom: 0.32rem;
	}
}
</style>
